import { RESET_STATE } from 'store/global/actions';

import { ADVISOR_PORTAL_CONFIGURATIONS_ACTION_TYPE } from '../actions';

const initialState = {
  list: [],
};

const advisorPortalConfigurationsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ADVISOR_PORTAL_CONFIGURATIONS_ACTION_TYPE.GET_LIST:
      return { ...state, list: Array.isArray(payload) ? payload : [] };

    case ADVISOR_PORTAL_CONFIGURATIONS_ACTION_TYPE.CREATE:
      return { ...state, list: [...state.list, payload] };

    case ADVISOR_PORTAL_CONFIGURATIONS_ACTION_TYPE.UPDATE:
      return {
        ...state,
        list: state.list.map(config =>
          config.advisorPortalConfigurationId === payload.advisorPortalConfigurationId
            ? payload
            : config,
        ),
      };

    case ADVISOR_PORTAL_CONFIGURATIONS_ACTION_TYPE.DELETE:
      return {
        ...state,
        list: state.list.filter(config => config.advisorPortalConfigurationId !== payload.id),
      };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default advisorPortalConfigurationsReducer;
